// @ts-check

/**
 * Function to validate sign-up email address.
 * @param {String} email Email address to be validated
 * @returns Empty string if validation passes, error message if validation failed
 */
const validateEmail = (email) => {
  if (!email) {
    return "validation.emailRequired";
  }
  
  // Basic structure check
  const basicRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!basicRegex.test(email)) {
    return "validation.emailInvalid";
  }
  
  
  const [local, domain] = email.split('@');
  
  // Check domain has letters (not just numbers)
  if (!/[a-zA-Z]/.test(domain)) {
    return "validation.emailDomainMustContainLetters";
  }
  
  // Check TLD is valid (2+ characters, contains letters)
  const domainParts = domain.split('.');
  const tld = domainParts[domainParts.length - 1];
  
  if (tld.length < 2) {
    return "validation.emailDomainExtensionTooShort";
  }
  
  if (!/[a-zA-Z]/.test(tld)) {
    return "validation.emailDomainExtensionMustContainLetters";
  }
  
  // Check no consecutive dots
  if (email.includes('..')) {
    return "validation.emailCannotContainConsecutiveDots";
  }
  
  return "";
};
module.exports = {
    validateEmail
}